// extracted by mini-css-extract-plugin
module.exports = {"inputs":"Form_inputs__3kkad"};